
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tiempo-real",
      function () {
        return require("private-next-pages/tiempo-real.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tiempo-real"])
      });
    }
  